// extracted by mini-css-extract-plugin
export default {"v-graphite":"#4A4A4A","v-white":"#FFF","hasLinks":"video_info__hasLinks__J2uB3","hasLinksWhite":"video_info__hasLinksWhite___Va7c"};